import { fetchError, fetchRequest, fetchSuccess} from "./actions";
import { fetch} from "../../repo/mcc";
import { isEmpty} from "ramda";
import { isAuthError} from "../index";
import { put, takeEvery} from "redux-saga/effects";
import { dirty } from "../session/actions";
import { MccActionTypes } from "./types";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const mcc = yield fetch(action.payload.id, action.payload.params);
    if (mcc.errors && !isEmpty(mcc.errors)) {
      if (isAuthError(mcc.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(mcc.errors)));
    } else {
      yield put(fetchSuccess(mcc));
    }
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(MccActionTypes.FETCH, handleFetch);
}

export default watchFetchRequest;
